import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { UitkCard } from 'uitk-react-cards';

// Components
import { ReviewsSummaryCompressed } from 'components/infosite/property-details/reviews-summary-compressed';
import { Breadcrumbs } from 'components/infosite/property-details/breadcrumbs.tsx';
import { LocalizedPropertyDetailsProps } from './index';
import { NoReviews } from 'components/infosite/property-details/no-reviews';
import { StaticGalleryMosaic } from 'components/infosite/static-gallery-mosaic';
import { WhatsAroundMap } from 'components/infosite/whats-around/whats-around-map';

@inject('routeStore', 'analytics', 'currentHotel')
@observer
export class RoninPropertyDetails extends React.Component<LocalizedPropertyDetailsProps> {
  public render() {
    const { currentHotel, gallery, mapModel } = this.props;
    const { reviews } = currentHotel;

    const hotelDetailedLocation =
      currentHotel.hotel && currentHotel.hotel.locationInfo && currentHotel.hotel.locationInfo.hotelDetailedLocation;
    const mapSrc = hotelDetailedLocation && hotelDetailedLocation.mapImageUrl;
    const showReviews = reviews && reviews.count;

    return (
      <div itemScope={true} itemType="https://schema.org/Hotel">
        <UitkCard className="property-details all-b-margin-three all-x-padding-three uitk-flat-border-top">
          <div className="uitk-grid uitk-cell all-y-padding-three all-x-gutter-three all-y-gutter-three">
            <section className="uitk-cell uitk-card-media all-cell-1-1">
              <Breadcrumbs breadcrumbsContent={currentHotel.breadcrumbs} isDateless={currentHotel.searchCriteria.isDateless} />
              <StaticGalleryMosaic gallery={gallery} />
            </section>
            <section className="uitk-flex uitk-cell s-cell-1-1 m-cell-1-1 l-cell-1-3 xl-cell-1-3">
              <UitkCard withBorder={true} className="all-y-padding-one all-x-padding-one">
                {mapSrc && <WhatsAroundMap src={mapSrc} rfrr=":PropertyDetailsMap.Open" mapModel={mapModel} />}
              </UitkCard>
            </section>
            <section className="uitk-cell s-cell-1-1 m-cell-1-1 l-cell-2-3 xl-cell-2-3">
              <UitkCard withBorder={true} className="all-y-padding-one all-x-padding-one">
                {showReviews ? <ReviewsSummaryCompressed /> : <NoReviews />}
              </UitkCard>
            </section>
          </div>
        </UitkCard>
      </div>
    );
  }
}
